import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "mobile-drag-drop/default.css";
import { polyfill as mobileDragPolyfill } from "mobile-drag-drop";
import App from "@/App";
import "@/errorTracker"; // Phase 93 — globaler window.onerror + unhandledrejection → /api/client-errors

// Aktiviert HTML5-Drag-&-Drop auf Touch-Geräten (iPad/Handy) — kein Code-Change
// nötig, alle existierenden `draggable` + `onDragStart`/`onDrop`-Handler
// funktionieren jetzt auch mit Finger-Gesten.
if (typeof window !== "undefined") {
  mobileDragPolyfill({ dragImageTranslateOverride: undefined, forceApply: false });
  // Passiver Scroll-Fix: verhindert dass Chrome/Safari die Touch-Events blockieren
  window.addEventListener("touchmove", () => { /* noop – ermöglicht dragover */ }, { passive: false });
}

// Suppress benign "ResizeObserver loop completed with undelivered notifications" warnings
// triggered by some Radix-UI primitives (Select inside Dialog). Otherwise the CRA dev
// error-overlay would intercept pointer events on the preview deployment.
if (typeof window !== "undefined") {
  const RO_MSG = "ResizeObserver loop";
  window.addEventListener("error", (e) => {
    if (e?.message && String(e.message).includes(RO_MSG)) e.stopImmediatePropagation();
  });
  window.addEventListener("unhandledrejection", (e) => {
    const msg = e?.reason?.message || "";
    if (String(msg).includes(RO_MSG)) e.stopImmediatePropagation();
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
